/* This file was automatically generated on 1562128164 */

/* eslint-disable global-require */
module.exports = {
  ArrayTypeName: require('./ArrayTypeName.js'),
  AssemblyAssignment: require('./AssemblyAssignment.js'),
  AssemblyBlock: require('./AssemblyBlock.js'),
  AssemblyCall: require('./AssemblyCall.js'),
  AssemblyCase: require('./AssemblyCase.js'),
  AssemblyFor: require('./AssemblyFor.js'),
  AssemblyIf: require('./AssemblyIf.js'),
  AssemblyLocalDefinition: require('./AssemblyLocalDefinition.js'),
  AssemblySwitch: require('./AssemblySwitch.js'),
  BinaryOperation: require('./BinaryOperation.js'),
  Block: require('./Block.js'),
  BooleanLiteral: require('./BooleanLiteral.js'),
  BreakStatement: require('./BreakStatement.js'),
  Conditional: require('./Conditional.js'),
  ContinueStatement: require('./ContinueStatement.js'),
  ContractDefinition: require('./ContractDefinition.js'),
  DecimalNumber: require('./DecimalNumber.js'),
  ElementaryTypeName: require('./ElementaryTypeName.js'),
  ElementaryTypeNameExpression: require('./ElementaryTypeNameExpression.js'),
  EmitStatement: require('./EmitStatement.js'),
  EnumDefinition: require('./EnumDefinition.js'),
  EnumValue: require('./EnumValue.js'),
  EventDefinition: require('./EventDefinition.js'),
  ExpressionStatement: require('./ExpressionStatement.js'),
  ForStatement: require('./ForStatement.js'),
  FunctionCall: require('./FunctionCall.js'),
  FunctionDefinition: require('./FunctionDefinition.js'),
  FunctionTypeName: require('./FunctionTypeName.js'),
  HexLiteral: require('./HexLiteral.js'),
  HexNumber: require('./HexNumber.js'),
  Identifier: require('./Identifier.js'),
  IfStatement: require('./IfStatement.js'),
  ImportDirective: require('./ImportDirective.js'),
  IndexAccess: require('./IndexAccess.js'),
  InheritanceSpecifier: require('./InheritanceSpecifier.js'),
  InlineAssemblyStatement: require('./InlineAssemblyStatement.js'),
  LabelDefinition: require('./LabelDefinition.js'),
  Mapping: require('./Mapping.js'),
  MemberAccess: require('./MemberAccess.js'),
  ModifierDefinition: require('./ModifierDefinition.js'),
  ModifierInvocation: require('./ModifierInvocation.js'),
  NewExpression: require('./NewExpression.js'),
  NumberLiteral: require('./NumberLiteral.js'),
  Parameter: require('./Parameter.js'),
  ParameterList: require('./ParameterList.js'),
  PragmaDirective: require('./PragmaDirective.js'),
  ReturnStatement: require('./ReturnStatement.js'),
  SourceUnit: require('./SourceUnit.js'),
  StateVariableDeclaration: require('./StateVariableDeclaration.js'),
  StringLiteral: require('./StringLiteral.js'),
  StructDefinition: require('./StructDefinition.js'),
  ThrowStatement: require('./ThrowStatement.js'),
  TupleExpression: require('./TupleExpression.js'),
  UnaryOperation: require('./UnaryOperation.js'),
  UserDefinedTypeName: require('./UserDefinedTypeName.js'),
  UsingForDeclaration: require('./UsingForDeclaration.js'),
  VariableDeclaration: require('./VariableDeclaration.js'),
  VariableDeclarationStatement: require('./VariableDeclarationStatement.js'),
  WhileStatement: require('./WhileStatement.js')
};